export default "__VITE_ASSET__11ee51d9__"